import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IVolunteerAttendance } from './models';
import { invalidateVolunteerRoster } from './useVolunteerRoster';

export const useCancelAttendanceMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: IVolunteerAttendance) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			attendanceId,
			impersonationContext,
		}: {
			attendanceId: string;
			activityId: string;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<IVolunteerAttendance>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `volunteering/attendance/${attendanceId}/cancel`,
				}),
				'POST'
			),
		onSuccess: (data, variables) => {
			invalidateVolunteerRoster(variables.activityId);
			onSuccess?.(data);
		},
		onError,
	});
};
